import { FC } from "react";
import { Paper, Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  RxBasicInfoDto,
  ExportDataItemDto,
} from "../../../../../../../api-client";
import { RxDetailView } from "./RxDetailView";
import { ExportDetailView } from "./ExportDetailView";

interface RightDetailPanelProps {
  selectedItem:
    | { type: "rx"; data: RxBasicInfoDto }
    | { type: "export"; data: ExportDataItemDto }
    | null;
}

export const RightDetailPanel: FC<RightDetailPanelProps> = ({
  selectedItem,
}) => {
  if (!selectedItem) {
    return (
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          borderRadius: 2,
          bgcolor: "#D9DFE2",
          border: "1px solid #e0e0e0",
        }}
      >
        <Box
          sx={{
            p: 1,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 60, color: "#bdbdbd", opacity: 0.5 }}
          />
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ fontWeight: 500 }}
          >
            Keine Auswahl
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ maxWidth: 300 }}
          >
            Wählen Sie ein Rezept oder Export-Daten aus der mittleren Spalte, um
            die Details anzuzeigen
          </Typography>
        </Box>
      </Paper>
    );
  }

  if (selectedItem.type === "rx") {
    return <RxDetailView rx={selectedItem.data} />;
  }

  return <ExportDetailView exportItem={selectedItem.data} />;
};
